import { render, staticRenderFns } from "./CalculaCoberturaEstoqueFutura.vue?vue&type=template&id=42369a82&scoped=true"
import script from "./CalculaCoberturaEstoqueFutura.vue?vue&type=script&lang=js"
export * from "./CalculaCoberturaEstoqueFutura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42369a82",
  null
  
)

export default component.exports